import { Link } from "@material-ui/core";
import Authorize from "components/Authorize";
import { reservationPermissions } from "components/Authorize/permissions/reservationPermissions";
import NotificationProvider from "components/NotificationProvider";
import ReservationButton from 'components/ReservationButton/ReservationButton';
import { FlagEntityTypes } from "features/flag/flagsConsts";
import statuses from "features/loads/loadStatusesWithIcons";
import { useGetLoadsQuery } from "features/loads/loadsSlice";
import useSortOptions from "hooks/useSortOptions";
import _, { first } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { arrayToObject } from "utils/object-util";
import { hasPermission, isAuthorized } from "../../components/Authorize/authorizeUtil";
import { permissionProfiles } from "../../components/Authorize/permissionProfiles";
import LoadButton from "../../components/LoadButton/LoadButton";
import FormatService from "../../services/formatService";
import { useGetClientsWithConfigsQuery } from '../clients/clientConfigSlice';
import { useGetClientsQuery } from "../clients/clientSlice";
import { useGetSubMarketsQuery } from "../lots/components/LotSubMarketsPage/lotSubMarketsSlice";
import { useGetLotsQuery } from "../lots/lotSlice";
import {
    hasAccessToAllClients,
    selectIsAccountManager,
    selectIsAdmin,
    selectIsClient,
    selectIsLoggedIn,
    selectIsOwner,
    userHasOneClient
} from "../user/userSlice";
import { FlagAsset } from "./Flags/FlagAsset";
import { useAddNewReportMutation } from "./Reports/reportSlice";
import { excludedTypes, vehicleExtendedFormatted, vehicle_detail_extended_type } from "./VehicleDetailExtended/VehicleDetailExtendedTypes";
import VehicleStatusView from "./VehicleStatus/VehicleStatusView";
import { useGetStatusesForClientQuery } from "./VehicleStatus/vehicleStatusSlice";
import VehicleTable from "./VehicleTable";
import { readinessStatuses, readinessTypes } from "./components/AssetReadiness/readinessUtil";
import AssetReadinessStatuses from "./components/AssetReadinessStatuses/AssetReadinessStatuses";
import { useGetReadinessQuery } from './readiness/readinessSlice.js';
import { getLPTypeName } from './vehicleConsts';
import { setFilters, setSearchVal } from "./vehicleFiltersSlice";
import { vehiclePageStyles } from "./vehiclePageStyle";
import { useGetVehicleTypesQuery, useGetVehiclesQuery, useLazySearchVehiclesQuery } from "./vehicleSlice";

const VehiclesPage = ({ }) => {
    const classes = vehiclePageStyles();
    const history = useHistory();

    let isAdmin = useSelector(selectIsAdmin);
    let isOwner = useSelector(selectIsOwner);
    let isAccountManager = useSelector(selectIsAccountManager);
    let isClient = useSelector(selectIsClient);
    const [includeHistory, setIncludeHistory] = useState(false);
    const isUserLoaded = useSelector(selectIsLoggedIn);

    const { searchVal, filters } = useSelector(state => state.vehicleFilters);
    const [sortOptions, sortData] = useSortOptions();
    const dispatch = useDispatch();
    const hasOneClaim = useSelector(userHasOneClient);

    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(100);

    const [selectedColumns, setSelectedColumns] = useState([]);

    let {
        data: vehiclesData,
        error: vehicleError,
        isFetching: isFetchingVehicles,
        refetch: refetchVehicles
    } = useGetVehiclesQuery({ includeHistory });
    let { data: vehicleTypes, error: vehicleTypesError, isLoading: isLoadingVehicleTypes } = useGetVehicleTypesQuery();
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    let {
        data: clients,
        error: clientError,
        isLoading: isLoadingClients
    } = useGetClientsQuery(null);
    let {
        data: vehicleStatuses,
        error: statusError,
        isLoading: isLoadingStatuses
    } = useGetStatusesForClientQuery({ clientId: 0 });
    let {
        data: clientsWithConfigs,
        error: clientsWithConfigsError,
        isFetching: isLoadingClientsWithConfigs
    } = useGetClientsWithConfigsQuery(null, { skip: !isUserLoaded });
    let { data: subMarkets, error: smError, isLoading: isLoadingSm } = useGetSubMarketsQuery();
    let {
        data: vehiclesReadiness,
        error: vehiclesReadinessError,
        isLoading: isLoadingVehiclesReadiness,
        refetch: reloadReadiness
    } = useGetReadinessQuery({}, { skip: isFetchingVehicles });
    let {
        data: loads,
        error: loadListError,
        isLoading: isLoadingLoads
    } = useGetLoadsQuery({});

    let { data: clientVehicleStatuses, error: clientVehicleStatusesError, loading: clientVehicleStatusesLoading } = useGetStatusesForClientQuery({ clientId: 0 })

    const [addNewReport] = useAddNewReportMutation();

    let canSeeAllClients = useSelector(hasAccessToAllClients);

    let [searchVehicleTrigger] = useLazySearchVehiclesQuery()

    vehiclesData = vehiclesData || []; //vehicleSearchData?.vehicles
    //vehicleSearchData = vehicleSearchData || [];
    vehicleTypes = vehicleTypes || [];
    lots = lots || [];
    clients = clients || [];
    vehicleStatuses = vehicleStatuses || [];
    clientVehicleStatuses = clientVehicleStatuses || []
    clientsWithConfigs = clientsWithConfigs || [];
    loads = loads || [];

    const clientVehicleStatusesLookup = clientVehicleStatuses?.reduce((map, obj) => {
        const id = obj.id;
        if (!map[id]) {
            map[id] = [];
        }
        map[id].push(obj);
        return map;
    }, {});

    const clientAccounts = _.flatten(clients?.map(c => c.clientAccounts));

    // useEffect(async () => {
    //     await refetchVehiclesSearch({
    //         includeHistory,
    //         page: page, 
    //         limit: limit, 
    //         search: searchVal, 
    //         columnToSort: sortOptions.columnToSort,
    //         sortDirection: sortOptions.sortDirection,
    //         lotId: parseInt(filters["lotId"]?.value)
    //         clientId: parseInt(filters["clientId"]?.value),
    //         vehicleStatusId: filters["vehicleStatusId"]?.value,
    //         vehicleTypeId: parseInt(filters["vehicleTypeId"]?.value),
    //         dateInStart: filters["formattedDateIn"]?.value?.startDate.toDateString(), 
    //         dateInEnd: filters["formattedDateIn"]?.value?.endDate.toDateString(), 
    //         dateOutStart: filters["formattedDateOut"]?.value?.startDate.toDateString(),
    //         dateOutEnd: filters["formattedDateOut"]?.value?.endDate.toDateString(),
    //         submarketId: filters["subMarketIds"]?.value,
    //         domicileLot: filters["domicileLot"]?.value
    //     });
    // }, [page, limit, searchVal, sortOptions]) //filters

    const isUsingTransports = clientsWithConfigs?.some(c => c?.config?.transportConfig?.useTransport);
    const isUsingReadiness = clientsWithConfigs?.some(c => c?.config?.readinessConfig?.readinessType != readinessTypes.OFF && c?.config?.readinessConfig?.readinessType != null)
    const canSeeFlags = isAuthorized(permissionProfiles.FLAGS.VIEW_FLAGS);
    const canEditFlags = isAuthorized(permissionProfiles.FLAGS.EDIT_FLAGS);
    const canOverrideInspectionReadiness = isAuthorized(permissionProfiles.ASSETS.ASSETS_PAGE_OVERRIDE_INSPECTION_READINESS);
    const canBulkEditVehicleStatus = isAuthorized(permissionProfiles.ASSETS.ASSETS_PAGE_BULK_EDIT_STATUS);
    const canExportCostReport = isAuthorized(permissionProfiles.ASSETS.ASSETS_COST_BREAKDOWN_EXPORT);

    const readinessByVehicleId = vehiclesReadiness?.reduce(function (map, obj) {
        map[obj.vehicleId] = obj;
        return map;
    }, {})

    const subMarketsForLot = {}
    subMarkets?.map(s => {
        s?.lotIds?.map(l => {
            subMarketsForLot[l] = [...(subMarketsForLot[l] ?? []), s.id + ""];
        })
    })

    const lotLookup = arrayToObject(lots);

    const isLoading = () => isFetchingVehicles || isLoadingLots || isLoadingVehicleTypes || isLoadingClients || isLoadingStatuses; // || isFetchingVehicleSearch

    const getLotName = id => {
        let lot = lotLookup?.[id] || {};
        return lot?.name ?? "";
    };

    const getClientName = clientId => {
        let client = clients?.find(c => c.id === clientId) || {};
        return client?.name ?? "";
    };

    const getStatusName = (id, clientId) => {
        var status = clientVehicleStatusesLookup?.[id]?.find(s => s.aliasClientId == clientId);
        if (status) {
            if (canSeeAllClients) return status?.name;
            else return status?.alias;
        }
        status = clientVehicleStatusesLookup?.[id]?.[0];
        return status ? status?.label : "";
    }

    const getStatusInternal = (id, clientId) => {
        var status = clientVehicleStatusesLookup?.[id]?.find(s => s.aliasClientId == clientId);
        if (status) {
            if (!canSeeAllClients) return "";
            else return status?.label;
        }
        status = clientVehicleStatusesLookup?.[id]?.[0];
        return status ? status?.label : "";
    }

    const getStatusAlias = (id, clientId) => {
        var status = clientVehicleStatusesLookup?.[id]?.find(s => s.aliasClientId == clientId);
        if (status) {
            if (!canSeeAllClients) return status?.name;
            else return status?.alias;
        }
        return "";
    }

    let vehicleColumns = [
        {
            name: "VIN", key: "descriptor", selectedByDefault: true, width: 280,
            component: (row) => {
                return <div style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                    <Link style={{ color: "#46535d", paddingLeft: 3 }} href={`/assets/detail/${row?.id}`}
                        target="_blank">{row?.descriptor}</Link>
                </div>
            }
        },
        {
            name: "Asset ID", key: "assetId", selectedByDefault: true, width: 200,
            component: (row) => {
                return <div style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                    <Link style={{ color: "#46535d", paddingLeft: 3 }} href={`/assets/detail/${row?.id}`}
                        target="_blank">{row?.assetId}</Link>
                </div>
            }
        },
        ...(hasOneClaim ? [] : [{ name: "Client", key: "client", selectedByDefault: true }]),
        { name: "Sub Client", key: "subClient", values: clientAccounts?.filter(a => a.isDefault == false), width: 200 },
        { name: "Driver Carrier", key: "driverCarrier", requireAdmin: true, selectedByDefault: true },
        { name: "Current Location", key: "lotId", values: lots, selectedByDefault: true, width: 200 },
        { name: "Vehicle Type", key: "vehicleTypeId", values: vehicleTypes, selectedByDefault: true, width: 200 },
        { name: "Created Date", key: "formattedCreatedDate", sortKey: "createdDate", selectedByDefault: true, sortable: true },
        { name: "Last In", key: "formattedDateIn", sortKey: "dateIn", selectedByDefault: true, sortable: true },
        { name: "Last Out", key: "formattedDateOut", sortKey: "dateOut", selectedByDefault: false, sortable: true, },
        { name: "Dwell Days", key: "daysOnLot", selectedByDefault: false, sortable: true, },
        ...(!canSeeAllClients ? [{
            name: "Status", key: "vehicleStatusId", selectedByDefault: true,
            component: (row) => {
                return <VehicleStatusView value={row.vehicleStatusId} clientId={row?.clientId} />
            }
        }] : []),
        ...(canSeeAllClients ? [
            { name: "Status", key: "statusInternal", selectedByDefault: false, width: 200 },
            { name: "Status Alias", key: "statusAlias", selectedByDefault: false, width: 200 }
        ] : []),
        { name: "Registration", key: "registration", selectedByDefault: false, width: 200 },
        { name: "License Plate", key: "licensePlate", selectedByDefault: false, width: 200 },
        { name: "Year", key: "year", selectedByDefault: false, },
        { name: "Make", key: "make", selectedByDefault: false, },
        { name: "Model", key: "model", selectedByDefault: false, },
        { name: "Mileage", key: "mileage", selectedByDefault: false, },
        { name: "Domicile Lot", key: "domicileLot", values: lots, selectedByDefault: false },
        { name: "Telematics", key: "lastGpsLocationFormatted", selectedByDefault: false },
        {
            name: "Open bill", key: "openBill", selectedByDefault: false,
            component: (row) => {
                return row?.openBill ? "Yes" : "No";
            }
        },
    ];

    const formatDates = (date, lotId) => {
        return FormatService.formatDateNoConversion(lotLookup?.[lotId]?.ianaTimeZone ? FormatService.formatDateByTimeZone(date, lotLookup?.[lotId]?.ianaTimeZone) : date)
    }

    const updateAssetProperties = (data) => {
        return data?.map(v => ({
            ...v,
            latestLoadId: readinessByVehicleId?.[v.id]?.latestLoadId,
            latestLoadStatus: readinessByVehicleId?.[v.id]?.latestLoadStatus,
            subMarketIds: subMarketsForLot?.[v.lotId],
            client: getClientName(v.clientId),
            subClient: clientAccounts?.find(c => c.id === v.customerId) ? v.customerId : null,
            driverCarrier: v?.driverCarrier,
            formattedDateIn: formatDates(v?.dateIn, v.lotId),
            dateIn: v?.dateIn,
            formattedDateOut: formatDates(v?.dateOut, v.lotId),
            dateOut: v?.dateOut,
            readinessStatus: readinessByVehicleId?.[v.id] ?? {},
            readinessStatusValue: readinessByVehicleId?.[v.id]?.status ?? {},
            registration: (v.registrationMonth && v.registrationYear) ? (("0" + v.registrationMonth).slice(-2) + ' ' + v.registrationYear + (v.registrationExpired ? ' (Expired)' : '')) : '',
            licensePlate: v.hasLicensePlate == false ? 'No License Plate' : (v.licensePlate && v.licensePlateState) ? (v.licensePlate + ' ' + v.licensePlateState + (getLPTypeName(v.licensePlateType) != null ? ' (' + getLPTypeName(v.licensePlateType) + ')' : '')) : '',
            licensePlateState: v.hasLicensePlate == false ? '' : v.licensePlateState,
            licensePlateType: v.hasLicensePlate == false ? '' : v.licensePlateType,
            flaggedStr: v.latestFlag ? 'Yes' : 'No',
            lastGpsLocationFormatted: v.lastGpsLocation ? `${v.lastGpsLocation?.lat} | ${v.lastGpsLocation?.long}` : '',
            statusInternal: getStatusInternal(v.vehicleStatusId, v.clientId),
            statusAlias: getStatusAlias(v.vehicleStatusId, v.clientId),
            formattedCreatedDate: formatDates(v?.createdDate, v.lotId),
            invalidVin: v.isValidVin ? 'No' : 'Yes',
        }));
    };

    vehiclesData = useMemo(() => updateAssetProperties(vehiclesData), [vehiclesData, vehiclesReadiness]);

    const columnsToAdd = {}

    vehiclesData?.map(v => {
        v.extendedDetails?.map(d => {
            v['extended_' + d.vehicleDetailExtendedTypeId] = d.value;
            if (!excludedTypes.includes(d.vehicleDetailExtendedTypeId) && d.vehicleDetailExtendedTypeId && !columnsToAdd['extended_' + d.vehicleDetailExtendedTypeId]) {
                columnsToAdd['extended_' + d.vehicleDetailExtendedTypeId] = {
                    name: d.label,
                    key: 'extended_' + d.vehicleDetailExtendedTypeId,
                    selectedByDefault: false,
                    component: (row) => vehicleExtendedFormatted({
                        vehicleDetailExtendedTypeId: d.vehicleDetailExtendedTypeId,
                        value: row['extended_' + d.vehicleDetailExtendedTypeId]
                    })
                }
            }
        })
        return v;
    })

    vehicleColumns = [...vehicleColumns, ...Object.values(columnsToAdd)]

    const vehicleLookup = arrayToObject(vehiclesData);

    if (canSeeFlags) {
        vehicleColumns.unshift({
            name: '',
            key: 'latestFlag',
            width: 80,
            selectedByDefault: true,
            customizable: false,
            component: (row) => {
                return <FlagAsset
                    iconOnly
                    selectedRows={[row?.id]}
                    flagOn={vehicleLookup?.[row?.id]?.latestFlag}
                    flagObj={vehicleLookup?.[row?.id]?.latestFlag}
                    sourceType={vehicleLookup?.[row?.id]?.latestFlag?.sourceType}
                    getFlagFromApi={false}
                    allData={vehiclesData}
                    entityType={FlagEntityTypes.ASSET}
                />
            }
        });
    }

    if (!isAdmin && !isAccountManager) {
        vehicleColumns = vehicleColumns.filter(c => !c.requireAdmin);
    }

    if (isAdmin || (isClient && isUsingTransports)) {
        vehicleColumns.push({
            width: 100,
            name: "Load",
            key: "latestLoadId",
            selectedByDefault: true,
            component: (row) => <>{row?.latestLoadId && <LoadButton latestLoadID={row?.latestLoadId} />}</>
        },);
    }
    if (isUsingReadiness) {
        vehicleColumns.push({
            name: "Readiness", sortKey: 'readinessStatusValue', width: 350, key: "readinessStatus", selectedByDefault: true, component: (row) => {
                return <AssetReadinessStatuses readinessStatus={row?.readinessStatus} showActivityList={true} />
            }
        });
    }
    if (hasPermission(reservationPermissions.VIEW.key) || isOwner || isAdmin || isAccountManager) {
        vehicleColumns.push({
            width: 180, name: 'Last Reservation', key: "latestReservation", selectedByDefault: true,
            component: (row) => <>{row?.latestReservation &&
                <>
                    <div>{row?.latestReservationId}</div>
                    <ReservationButton reservationId={row?.latestReservation} />
                </>
            }
            </>
        });
    }

    const [assetToEdit, setAssetToEdit] = useState(null);
    const [assetToAdd, setAssetToAdd] = useState(null);

    const viewVehicle = (id) => {
        history.push(`/assets/detail/${id}`);
    };

    const onEdit = id => {
        let vehicle = vehiclesData.find(v => v.id === id);
        setAssetToEdit(vehicle);
    };

    const onAdd = () => {
        let asset = {};
        asset.vehicleTypeId = first(vehicleTypes)?.id;
        asset.vehicleStatusId = first(vehicleStatuses)?.id;
        asset.lotId = first(lots)?.id;
        asset.clientId = first(clientAccounts)?.clientId;
        asset.customerId = first(clientAccounts)?.id;
        setAssetToAdd(asset);
    };

    const reloadAssets = () => {
        setAssetToEdit(null);
        setAssetToAdd(null);
        refetchVehicles();
    };

    const getReadinesToExport = (readinessStatus) => {
        let result = '';
        const clientConfig = clientsWithConfigs?.find(c => c.id == readinessStatus?.clientId);
        const isUsingManualReadiness = clientConfig?.config?.readinessConfig?.readinessType == readinessTypes.MANUAL;

        // Same guard as the AssetReadinessStatuses badge — when readiness isn't shown
        // in the table cell, the exported cell must be empty too.
        const showReadiness = isUsingManualReadiness || readinessStatus?.status;
        if (!showReadiness) {
            return result;
        }

        let readinessValues = isUsingManualReadiness ? clientConfig?.readinessOptions?.map(opt => {
            const vehicleReadiness = readinessStatus?.readinessValues?.find(r => r.readinessConfigId === opt.id);
            const readinessStatusForVehicle = vehicleReadiness?.status ?? readinessStatuses.RED;
            return {
                ...vehicleReadiness,
                status: readinessStatusForVehicle,
                text: opt?.[`statusText${readinessStatusForVehicle}`]
            }
        }) : [
            ...(readinessStatus?.washStatus ? [{
                status: readinessStatus?.washStatus ?? readinessStatus.RED,
                text: 'Washed'
            }] : []),
            ...(readinessStatus?.paveStatus ? [{
                status: readinessStatus?.paveStatus ?? readinessStatus.RED,
                text: 'Passed PAVE'
            }] : []),
            ...(readinessStatus?.preDeliveryRepairsStatus ? [{
                status: readinessStatus?.preDeliveryRepairsStatus ?? readinessStatus.RED,
                text: 'Repaired'
            }] : []),
            ...(readinessStatus?.ameritInspectionStatus ? [{
                status: readinessStatus?.ameritInspectionStatus ?? readinessStatus.RED,
                text: 'Inspected'
            }] : []),
            ...(readinessStatus?.internalInspectionStatus ? [{
                status: readinessStatus?.internalInspectionStatus ?? readinessStatus.RED,
                text: 'Inspected'
            }] : [])
        ];

        readinessValues?.map((opt, index) =>
            result += (index === 0) ? opt.text : (`( ${opt.text} )`)
        )

        // For manual readiness, derive the effective status from all configured options (same logic
        // as the UI badge), because the backend status only reflects options that have a DB record —
        // options that were never explicitly set are missing from the backend result and would
        // incorrectly make the overall status appear Green.
        const effectiveStatus = isUsingManualReadiness && readinessValues?.length > 0
            ? Math.max(...readinessValues.map(r => r.status))
            : readinessStatus.status;

        result += effectiveStatus ? (effectiveStatus == readinessStatuses.GREEN ? ' (Ready)' : ' (Not ready)') : '';
        return result;
    }

    useEffect(() => {
        let filterField = history?.location?.state?.params?.filters;
        if (filterField) {
            for (let i in filterField) {
                updateFilters(i, filterField[i]);
            }
        }
    }, [])

    const onDropFilter = (filterValue, prop) => {
        updateFilters(prop, filterValue);
    };

    const updateFilters = (prop, value) => {
        setPage(1);
        if (prop == 'domicileLot') {
            if (value) {
                setIncludeHistory(true);
            }
        }
        let newFilters;
        if (prop === 'clientId') {
            newFilters = { ...filters, [prop]: { value }, ["subClient"]: { value: null } }
        } else {
            newFilters = { ...filters, [prop]: { value } }
        }
        dispatch(setFilters(newFilters));
    }

    const searchVehicles = value => {
        setPage(1);
        dispatch(setSearchVal(value.trim()));
    }

    const updateAllFilters = (newFilters) => {
        setPage(1);
        if (newFilters?.['domicileLot']?.value) {
            setIncludeHistory(true);
        }
        dispatch(setFilters(newFilters));
        //saveFilters && saveFilters(newFilters)
    }

    // const getDataForExport = async () => {
    //     let allVehicles = await searchVehicleTrigger({
    //         includeHistory, 
    //         page: null, 
    //         limit: null, 
    //         search: searchVal, 
    //         columnToSort: sortOptions.columnToSort,
    //         sortDirection: sortOptions.sortDirection,
    //         lotId: filters["lotId"]?.value ? parseInt(filters["lotId"]?.value) : null,
    //         clientId: filters["clientId"]?.value ? parseInt(filters["clientId"]?.value) : null,
    //         vehicleStatusId: filters["vehicleStatusId"]?.value,
    //         vehicleTypeId: filters["vehicleTypeId"]?.value ? parseInt(filters["vehicleTypeId"]?.value) : null,
    //         dateInStart: filters["formattedDateIn"]?.value?.startDate.toDateString(), 
    //         dateInEnd: filters["formattedDateIn"]?.value?.endDate.toDateString(), 
    //         dateOutStart: filters["formattedDateOut"]?.value?.startDate.toDateString(),
    //         dateOutEnd: filters["formattedDateOut"]?.value?.endDate.toDateString(),
    //         submarketId: filters["subMarketIds"]?.value,
    //         domicileLot: filters["domicileLot"]?.value,
    //     });  
    //     allVehicles = updateAssetProperties(allVehicles?.data?.vehicles)
    //     return allVehicles;
    // }

    const getKeysNumber = (vehicle) => {
        let result = '';
        let object = vehicle?.extendedDetails?.find(x => x.vehicleDetailExtendedTypeId == 18);
        if (object) return object?.value ?? result;
        return result;
    }

    const getFobsNumber = (vehicle) => {
        let result = '';
        let object = vehicle?.extendedDetails?.find(x => x.vehicleDetailExtendedTypeId == 19);
        if (object) return object?.value ?? result;
        return result;
    }

    const getLastStatusLoad = (vehicle) => {
        let loadsCopy = [...loads];
        let load = loadsCopy.find((load) => load.id == vehicle.latestLoadId);
        if (load) {
            const latestStatus = load?.latestStatusObject ?? {};
            return statuses[latestStatus.status]?.label;
        }
        return '';
    }

    const getReportRequestByReportType = async (reportType, data) => {
        if (reportType == 2) {
            const allDataMap = data.map((v) => {
                const getExtVal = (typeId) => {
                    const value =
                        v[`extended_${typeId}`] ||
                        v.extendedDetails?.find(
                            d => d.vehicleDetailExtendedTypeId === typeId
                        )?.value ||
                        "";

                    // If Charge Level add battery for excel export
                    if (typeId === 91 && value.trim() !== "") {
                        return `${value} battery`;
                    }

                    return value;
                };

                const toPascalCase = (str) =>
                    str
                        ?.replace(/[^a-zA-Z0-9 ]/g, '')
                        ?.split(' ')
                        ?.map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        ?.join('');

                const selectedColumnKeys = selectedColumns?.map(c => c.key) || [];

                const extendedMapped = Object.entries(vehicle_detail_extended_type)
                    .reduce((acc, [key, value]) => {
                        const column = vehicleColumns.find(
                            c => c.key === `extended_${value}`
                        );
                        if (!column) return acc;
                        if (!selectedColumnKeys.includes(column.key))
                            return acc;
                        acc[toPascalCase(column.name)] = getExtVal(value);
                        return acc;
                    }, {});

                return {
                    ID: v.id,
                    VIN: v.descriptor,
                    ["AssetID"]: v.assetId,
                    Client: v.client,
                    ClientId: v.clientId,
                    "CurrentLocation": getLotName(v.lotId),
                    "DomicileLot": getLotName(v.domicileLot),
                    "DriverCarrier": v.driverCarrier,
                    Year: v.year,
                    Make: v.make,
                    Model: v.model,
                    Trim: v.trim,
                    Mileage: v.mileage,
                    "CreatedDate": v.formattedCreatedDate,
                    "LastIn": v.formattedDateIn,
                    "LastOut": v.formattedDateOut,
                    "DaysOnLot": v.daysOnLot,
                    Status: canSeeAllClients ? getStatusInternal(v.vehicleStatusId, v.clientId) : getStatusName(v.vehicleStatusId, v.clientId),
                    "StatusAlias": canSeeAllClients ? getStatusAlias(v.vehicleStatusId, v.clientId) : "",
                    "Registration": v.registration,
                    "LicensePlate": v.licensePlate,
                    "SubClient": clientAccounts?.find(c => (c.id === v.customerId && c.isDefault == false))?.name,
                    "ConditionReport": v.conditionReportUrl,
                    "AssetType": vehicleTypes?.find(vt => vt.id == v.vehicleTypeId)?.name,
                    "Readiness": getReadinesToExport(v.readinessStatus),
                    "Load": getLastStatusLoad(v),
                    "LicensePlateNumber": v.licensePlate?.replace(`${v.licensePlateState}`, '')?.replace(`(${getLPTypeName(v.licensePlateType)})`, ''),
                    "LicensePlateState": v.licensePlateState,
                    "LicensePlateType": getLPTypeName(v.licensePlateType),
                    "Key": getKeysNumber(v),
                    "Fob": getFobsNumber(v),
                    "LastReservation": v.latestReservationId,
                    ...extendedMapped
                }
            });
            return allDataMap;
        } else if (reportType == 1) {
            const allDataMap = data.map((v) => (
                {
                    ID: v.id,
                    VIN: v.descriptor,
                    "AssetType": vehicleTypes?.find(vt => vt.id == v.vehicleTypeId)?.name,
                    ["AssetID"]: v.assetId,
                    Status: canSeeAllClients ? getStatusInternal(v.vehicleStatusId, v.clientId) : getStatusName(v.vehicleStatusId, v.clientId),
                    "StatusAlias": canSeeAllClients ? getStatusAlias(v.vehicleStatusId, v.clientId) : "",
                    "CurrentLocation": getLotName(v.lotId),
                    "DriverCarrier": v.driverCarrier,
                    "SubClient": clientAccounts?.find(c => (c.id === v.customerId && c.isDefault == false))?.name,
                }
            ));
            return allDataMap;
        } else if (reportType == 3) {
            const allDataMap = data.map((v) => (
                {
                    Id: v.id,
                    VIN: v.descriptor,
                    ["AssetID"]: v.assetId,
                    Client: v.client,
                    ClientId: v.clientId,
                    "CurrentLocation": getLotName(v.lotId),
                    "DomicileLot": getLotName(v.domicileLot),
                    "DriverCarrier": v.driverCarrier,
                    Year: v.year,
                    Make: v.make,
                    Model: v.model,
                    Trim: v.trim,
                    Mileage: v.mileage,
                    "LastIn": v.formattedDateIn,
                    "LastOut": v.formattedDateOut,
                    "DaysOnLot": v.daysOnLot,
                    Status: canSeeAllClients ? getStatusInternal(v.vehicleStatusId, v.clientId) : getStatusName(v.vehicleStatusId, v.clientId),
                    "StatusAlias": canSeeAllClients ? getStatusAlias(v.vehicleStatusId, v.clientId) : "",
                    "Registration": v.registration,
                    "LicensePlate": v.licensePlate,
                    "ConditionReport": v.conditionReportUrl,
                    "AssetType": vehicleTypes?.find(vt => vt.id == v.vehicleTypeId)?.name,
                    "Readiness": getReadinesToExport(v.readinessStatus),
                    "Load": getLastStatusLoad(v),
                    "LicensePlateNumber": v.licensePlate?.replace(`${v.licensePlateState}`, '')?.replace(`(${getLPTypeName(v.licensePlateType)})`, ''),
                    "LicensePlateState": v.licensePlateState,
                    "LicensePlateType": getLPTypeName(v.licensePlateType),
                    "Key": getKeysNumber(v),
                    "Fob": getFobsNumber(v),
                    lastGpsLocationFormatted: v.lastGpsLocationFormatted,
                    "SubClient": clientAccounts?.find(c => (c.id === v.customerId && c.isDefault == false))?.name,
                }
            ));
            return allDataMap;
        }
    }

    function downloadBase64File(contentType, base64Data, fileName) {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const customExportReportEvent = async (reportType, data) => {
        NotificationProvider.success("Your report is being created, it will be downloaded automatically in a moment. \n You can also see the status of each report in the My Reports section");
        let csvData = await getReportRequestByReportType(parseInt(reportType), data);

        let requestData = {
            ReportType: parseInt(reportType),
            JSON: JSON.stringify(csvData),
            Columns: selectedColumns?.map(c => c.name) || []
        };

        let result = await addNewReport(requestData);
        if (result && !result.error) {
            downloadBase64File(result?.data?.type, result?.data?.content, result?.data?.name);
        } else {
            let concatenateError = result?.error?.data?.messages[0];
            NotificationProvider.error(concatenateError);
        }
    }

    return (
        <div
            className="Vehicles">
            <Authorize profile={permissionProfiles.ASSETS.ASSETS_PAGE_VIEW_ASSET_TABLE}>
                <VehicleTable
                    vehiclesData={vehiclesData}
                    columns={vehicleColumns}
                    isLoading={isLoading()}
                    assetToEdit={assetToEdit}
                    setAssetToEdit={setAssetToEdit}
                    assetToAdd={assetToAdd}
                    setAssetToAdd={setAssetToAdd}
                    updateAsset={reloadAssets}
                    addAsset={reloadAssets}
                    reloadReadiness={reloadReadiness}
                    includeHistory={includeHistory}
                    setIncludeHistory={setIncludeHistory}
                    onAdd={onAdd}
                    onEdit={onEdit}
                    viewVehicle={viewVehicle}
                    setPage={setPage}
                    limit={limit}
                    setLimit={setLimit}
                    searchVal={searchVal}
                    filters={filters}
                    onDropFilter={onDropFilter}
                    searchVehicles={searchVehicles}
                    sortData={sortData}
                    sortOptions={sortOptions}
                    updateAllFilters={updateAllFilters}
                    customExportChild={customExportReportEvent}
                    canSeeFlags={canSeeFlags}
                    canOverrideInspectionReadiness={canOverrideInspectionReadiness}
                    canEditFlags={canEditFlags}
                    canBulkEditVehicleStatus={canBulkEditVehicleStatus}
                    canExportCostReport={canExportCostReport}
                    onSelectedColumnsChange={setSelectedColumns}
                />
            </Authorize>
        </div>
    );
};

export default VehiclesPage
